import React, { useContext, useState } from 'react'
import { useNavigate, useParams, Link } from 'react-router-dom'
import styled from 'styled-components'
import * as FaIcons from "react-icons/fa";
import * as AiIcons from "react-icons/ai";
import { GrClose } from "react-icons/gr"
import { SideBarData } from "./sidebardata";

import { IconContext } from "react-icons/lib";
import { SubMenu } from './submenu'
import './sidebar.css'

import { useSelector, useDispatch } from 'react-redux';
import { logout, reset } from '../../../features/auth/authSlice';

import {
    active_collections,
    active_dashboard,
    active_drop,
    active_faqs,
    active_newspaper,
    active_resources,
    active_settings,
    active_users,
    collections_icon,
    dashboard_icon,
    drop_icon,
    faqs_icon,
    newspaper_icon,
    resources_icon,
    settings_icon,
    users_icon,
    logo,
    logout_icon
} from '../../../../assets'

const SideBar = ({setShowSideBar}) => {

    const [sidebar, setSidebar] = useState(false);
    const [mobileViewWidth, setMobileViewWidth] = useState(document.body.clientWidth)
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const { user } = useSelector(state => state.auth);
    
    const onLogOut = () => {
        dispatch(logout());
        dispatch(reset());
        navigate('/login');
    }

    useState(()=> {
        window.addEventListener('resize', function(){
            setMobileViewWidth(document.body.clientWidth)
        })
    }, [document.body.clientWidth])
        
    return (
    <Container>
        <InnerContainer>
           <Flex>
                <Link to='/'> <Logo src={logo} alt="logo" /> </Link>
                {mobileViewWidth < 1000 ? <AnimatedBtn onClick={()=> setShowSideBar(false)} className="">&times;</AnimatedBtn> : null}
           </Flex>

            <SidebarNav sidebar={sidebar}>
                <SidebarWrap>
                    {SideBarData.map((item, index) => {
                    return <SubMenu item={item} key={index} />;
                    })}
                </SidebarWrap>
            </SidebarNav>
            
            <div className="logout" onClick={onLogOut} >
                <img src={logout_icon} alt="logout" />
                <p>Logout</p>
            </div>
        </InnerContainer>
    </Container>
  )
}

const Flex = styled.div `
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    padding: 20px;

    & > button {
        border: none;
        background: transparent;
        outline: none;
        color: #ffffff;
        font-size: 5rem;
    }
`


const Logo = styled.img `
    
`

const Container = styled.section`
    background-color: #2A3E4C;
    height: 100%;
    position: relative;
    width: 100%;

    @media only screen and (max-width: 550px) {
        width: 60vw;
        position: absolute;
        left: 0;
        top: 0;
    }

    @media only screen and (max-width: 1000px) and (min-width: 550px) {
        width: 35vw;
        position: absolute;
        left: 0;
        top: 0;
    }
    
`

const InnerContainer = styled.div`
    display: flex;
    flex-direction: column;
    /* align-items: center; */
    

    & > img {
        width: 40%;
    }

    & > li{
        font-size: 16px;
        color: #fff;
        flex: 1;
        list-style: none;
        padding-top: 10px;

        & > li{
            margin-top: 15px;
            padding-top: 10px;
            align-items: center;
        }
    }
`

  
const SidebarNav = styled.nav`
  display: flex;
  justify-content: center;
  margin-top: 3rem;
  /* left: ${({ sidebar }) => (sidebar ? "0" : "-100%")}; */
  transition: 350ms;
`;
  
const SidebarWrap = styled.div`
  width: 100%;
`;

const AnimatedBtn = styled.button`
    position: absolute;
    right: 20px;
    top: 20px;
    font-weight: lighter;
    color: #fff;
`


export {SideBar}































// import React, { useContext, useState } from 'react'
// import { useNavigate, useParams } from 'react-router-dom'
// import styled from 'styled-components'
// import classes from './sidebar.css'

// import {
//     active_collections,
//     active_dashboard,
//     active_drop,
//     active_faqs,
//     active_newspaper,
//     active_resources,
//     active_settings,
//     active_users,
//     collections_icon,
//     dashboard_icon,
//     drop_icon,
//     faqs_icon,
//     newspaper_icon,
//     resources_icon,
//     settings_icon,
//     users_icon,
//     logo,
//     logout_icon
// } from '../../../../assets'

// const SideBar = () => {

//     const navigate = useNavigate();
//     const params = useParams();

//     const [tabItems, setTabItems] = useState ([
//         { text: "Home", TabIcon: dashboard_icon, TabIconActive: active_dashboard, active: params.route === "/", },
//         { text: "My Collections", TabIcon: collections_icon, TabIconActive: active_collections, active: params.route === "my-collections" },
//         { text: "Resources", TabIcon: resources_icon, TabIconActive: active_resources, dropIcon: drop_icon, active: params.route === "resources",
//             subItems: [
//             {subText: "Category", active: params.route === "category"},
//             {subText: "Tags", active: params.route === "tags"}
        
//         ] },

//         { text: "FAQs", TabIcon: faqs_icon, TabIconActive: active_faqs, active: params.route === "faqs" },
//         { text: "Newspapers", TabIcon: newspaper_icon, TabIconActive: active_newspaper, active: params.route === "newspaper" },
//         { text: "Users", TabIcon: users_icon, TabIconActive: active_users, active: params.route === "users" },
//         { text: "Settings", TabIcon: settings_icon, TabIconActive: active_settings, dropIcon: drop_icon, active: params.route === "settings", 
//             subItems: [
//                 {subText: "Roles", active: params.route === "roles"},
//                 {subText: "Permissions", active: params.route === "permissions"}
//             ] },
        
//     ]);

//     const initialFocusRef = React.useRef()

//     const changeActiveTab = (idx, text) => {
//         console.log(idx, text);
        
//         tabItems.forEach(tab => tab.active = false);

        
//         const tabsCopy = tabItems.filter(tab => tab.active === false);

    
//         tabsCopy[idx].active = true;
//         setTabItems(tabsCopy);
        
//         navigate(text === "Dashboard" ? "/dashboard/home" : `/dashboard/${text.toLowerCase().replace(" ", "-")}`);
//     }


//     let navLinks = [];
  
//     return (
//     <Container>
//         <InnerContainer>
//             <img src={logo} alt="logo" />
//                 <li className='sidebar_container'>
//                         {
//                             tabItems.map(({ TabIcon, TabIconActive, text, active, dropIcon, subItems, subText}, idx) => (
//                                 <li className="side_list" key={idx} onClick={() => changeActiveTab(idx, text)} padding="4" pl="8" cursor="pointer" display="flex" borderRadius="8px" borderTopLeftRadius="0" borderBottomLeftRadius="0" alignItems="center" bg={active ? "#73DA9E" : null} color={active ? "#fff" : "#57575b"}>
//                                     {<img color="#fff" src={active ? TabIconActive : TabIcon} alt={text} mr="18px" />}
//                                     {<p className={active ? "option_active" : null} >{text}</p> }
//                                     {<img src={dropIcon} alt="" className="drop_icon" />  }

                                    
//                                 </li>
//                             ))
//                         }
//                 </li>
//             <div className="logout">
//                 <img src={logout_icon} alt="logout" />
//                 <p>Logout</p>
//             </div>
//         </InnerContainer>
//     </Container>
//   )
// }

// const Container = styled.section`
//     background-color: #2A3E4C;
//     height: 100%;
// `

// const InnerContainer = styled.div`
//     display: flex;
//     flex-direction: column;
//     align-items: center;

//     & > li{
//         font-size: 16px;
//         color: #fff;
//         flex: 1;
//         list-style: none;
//         padding-top: 10px;

//         & > li{
//             margin-top: 15px;
//             padding-top: 10px;
//             align-items: center;
//         }
//     }
// `

// export {SideBar}